// extracted by mini-css-extract-plugin
module.exports = {"full-width":"_2DttNuTMGK1-YfN56KpkqP"};